import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenusState } from 'src/interface/menus/menus.interface';

const initialState: MenusState = {
  route: [],
  routeflat: [],
  moduleRoute: [],
  menuRoute: [],
  module: '',
  menuCode: ''
};

const menusSlice = createSlice({
  name: 'menus',
  initialState,
  reducers: {
    setMenus(state, action: PayloadAction<Partial<MenusState>>) {
      Object.assign(state, action.payload);
    }
  }
});

export const { setMenus } = menusSlice.actions;

export default menusSlice.reducer;